export default {
  type: "webdev",
  img: "fcc_secondary_small.png",
  id: 'freeCodeCamp_Certifications',
  text: {
    title: "freeCodeCamp Certifications",
    description: "description"
  }
};
